"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = exports.applyRetainedQueryParams = exports.decodeUriComponentIfEncoded = exports.getRelativeUrl = exports.removeLeadingAndTrailingSlash = exports.getRelativeUrlData = exports.getRelativeEncodedUrl = void 0;
const getRelativeEncodedUrl = (url, baseUrl) => (0, exports.getRelativeUrlData)(url, baseUrl).relativeEncodedUrl;
exports.getRelativeEncodedUrl = getRelativeEncodedUrl;
const getRelativeUrlData = (url, baseUrl) => {
    const relativePathname = getRelativePathname(url, baseUrl);
    const relativePathnameParts = getPathnameDecodedParts(relativePathname);
    const relativeUrl = pathnamePartsToRelativeUrl(relativePathnameParts);
    const relativeEncodedUrl = pathnamePartsToRelativeUrl(getPathnameParts(relativePathname));
    return {
        relativePathnameParts,
        relativeUrl,
        relativeEncodedUrl,
    };
};
exports.getRelativeUrlData = getRelativeUrlData;
const getRelativePathname = (url, baseUrl) => {
    const parsedUrl = new URL(url, `${baseUrl}/`);
    const parsedBaseUrl = new URL(baseUrl);
    return parsedUrl.pathname.replace(parsedBaseUrl.pathname, '');
};
const getPathnameDecodedParts = (relativePathname) => {
    const cleanPath = (0, exports.removeLeadingAndTrailingSlash)(relativePathname);
    return (0, exports.decodeUriComponentIfEncoded)(cleanPath).split('/');
};
const pathnamePartsToRelativeUrl = (pathnameParts) => `./${pathnameParts.join('/')}`;
const getPathnameParts = (relativePathname) => (0, exports.removeLeadingAndTrailingSlash)(relativePathname).split('/');
const removeLeadingAndTrailingSlash = (str) => /^\/?(.*?)\/?$/.exec(str)[1];
exports.removeLeadingAndTrailingSlash = removeLeadingAndTrailingSlash;
const getRelativeUrl = (url, baseUrl) => (0, exports.getRelativeUrlData)(url, baseUrl).relativeUrl;
exports.getRelativeUrl = getRelativeUrl;
const decodeUriComponentIfEncoded = (uriStr) => {
    try {
        return decodeURIComponent(uriStr);
    }
    catch (e) {
        return uriStr;
    }
};
exports.decodeUriComponentIfEncoded = decodeUriComponentIfEncoded;
const applyRetainedQueryParams = (browserCurrentUrl, targetHref, queryParamsWhitelist) => {
    const urlWithProtocol = targetHref.startsWith('//') ? `${browserCurrentUrl.protocol}${targetHref}` : targetHref;
    const targetUrl = new URL(urlWithProtocol);
    if (browserCurrentUrl.host === targetUrl.host) {
        const siteQueryParams = browserCurrentUrl.searchParams;
        siteQueryParams.forEach((value, key) => {
            if (queryParamsWhitelist?.has(key) && !targetUrl.searchParams.has(key)) {
                targetUrl.searchParams.set(key, value);
            }
        });
    }
    return targetUrl;
};
exports.applyRetainedQueryParams = applyRetainedQueryParams;
const getUserAgent = (window) => window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent.toLowerCase() : '';
const isSafari = (window) => {
    const userAgent = getUserAgent(window);
    return userAgent.indexOf('safari') > -1 && userAgent.indexOf('version') > -1;
};
exports.isSafari = isSafari;
//# sourceMappingURL=utils.js.map